export const getUpdatePendingCount = (state) => {
  return state.updatePending
}

export const recentHistory = (state) => {
  return state.history.slice(-5).join(', ')
}
